import Vue from 'vue';
import { AbstractModel } from '.';

let currentParticipant = {};

class model extends AbstractModel {
    endpoint = 'participant';

    getCurrentParticipant(responseGroup = 'current_participant', forceUpdate = false) {
        if (!currentParticipant[responseGroup] || forceUpdate) {
            return this.get({
                params: {
                    'response-group': responseGroup,
                    filter: [
                        {
                            type: 'eq',
                            field: 'currentParticipant',
                            value: true,
                        },
                    ],
                },
            }).then(r => {
                return (currentParticipant[responseGroup] = r.data[0]);
            });
        }

        return Promise.resolve(currentParticipant[responseGroup]);
    }

    loadOrganizationContacts(page, limit, filterQuery) {
        const filters = [];
        filters.push({
            type: 'eq',
            field: 'organization',
            value: Vue.$store.state.organization.selectedOrganizationID,
        });
        if (filterQuery) {
            const nameFilter = [];
            filterQuery.split(' ').forEach(namePart => {
                nameFilter.push({
                    field: 'firstname',
                    type: 'like',
                    value: `%${namePart}%`,
                });
                nameFilter.push({
                    field: 'lastname',
                    type: 'like',
                    value: `%${namePart}%`,
                });
            });
            filters.push({
                type: 'orx',
                conditions: nameFilter,
            });
        }
        return this.get({
            params: {
                limit,
                page,
                'response-group': 'org_backend_contacts_list',
                filter: filters,
                'order-by': [
                    {
                        field: 'isNew',
                        direction: 'DESC',
                        type: 'field',
                    },
                    {
                        field: 'firstname',
                        direction: 'ASC',
                        type: 'field',
                    },
                    {
                        field: 'id',
                        direction: 'DESC',
                        type: 'field',
                    },
                ],
            },
        });
    }

    loadParticipants(filters) {
        return this.get({
            params: {
                'response-group': 'short',
                filter: filters,
                'order-by': [
                    {
                        field: 'firstname',
                        direction: 'ASC',
                        type: 'field',
                    },
                ],
                limit: -1,
            },
        }).then(r => r.data);
    }

    getLegalTerms() {
        const url = `${process.env.VUE_APP_FE_HOST}/wp-json/wp/v2/posts?slug=${process.env.VUE_APP_PRIVACY_PAGE_URL}`;
        return fetch(url)
            .then(response => {
                if (!response.ok) {
                    return [];
                } else {
                    return response.json();
                }
            })
            .catch(() => {
                return [];
            })
            .then(pages => {
                if (pages.length) {
                    const [page] = pages;
                    return page.content.rendered.replaceAll("\n<p><br>\n</p>", '');
                }
                return '';
            });
    }
}

export const ParticipantModel = new model();
